export class PackageResponse {
  /**
   * @param {Object} response
   * @param {Number} response.id
   * @param {String} response.name
   * @param {String} response.detail
   * @param {Number} response.billing_cycle
   * @param {Number} response.price
   * @param {Number} response.original_price
   * @param {String} response.target
   * @param {String} response.image_url
   * @param {String[]} response.service_ids
   * @param {PackageGroup[]} response.package_groups
   */
  constructor(response) {
    this.id = response.id;
    this.name = response.name;
    this.detail = response.detail;
    this.billingCycle = response.billing_cycle;
    this.price = response.price;
    this.originalPrice = response.original_price;
    this.target = response.target;
    this.imageUrl = response.image_url;
    this.serviceIds = response.service_ids;
    this.packageGroups = response.package_groups
      ? response.package_groups.map((group) => new PackageGroup(group))
      : [];
  }
}

export class PackageGroup {
  /**
   * @param {Object} response
   * @param {String} response.id
   * @param {String} response.name
   */
  constructor(response) {
    this.id = response.id;
    this.name = response.name;
  }
}


// WEBPACK FOOTER //
// ./src/features/subscriptions/modules/packages/models/PackageResponse.js